import { TAB_ORDER } from "./constants";
import type { TabName } from "./types";

const DEFAULT_TAB: TabName = "notes";
const TAB_SET = new Set<string>(TAB_ORDER);

export function tabFromPath(pathname: string): TabName {
  if (!pathname) return DEFAULT_TAB;
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return DEFAULT_TAB;
  // Support legacy /app/{tab} paths from bookmarks and iOS fallback links
  const candidate = parts[0] === "app" ? (parts[1] || DEFAULT_TAB) : parts[0];
  return TAB_SET.has(candidate) ? (candidate as TabName) : DEFAULT_TAB;
}

export function pathForTab(tab: TabName): string {
  const safeTab = TAB_SET.has(tab) ? tab : DEFAULT_TAB;
  return safeTab === DEFAULT_TAB ? "/" : `/${safeTab}`;
}
